import { useState } from 'react';

import ModalShell from '../components/ModalShell.jsx';

// Copy this zone's whole week onto ONE other same-type zone. Unlike the day copy
// (which edits this zone's draft), this commits directly to the target zone over
// the WebSocket — so the parent owns the dispatch and the request status; this is
// the presentational picker. Targets in Holiday / Override / Offline come through
// settingsLocked and are disabled (they can't accept a schedule).
export default function CopyWeekModal({
  targets,
  loading,
  error,
  onCopy,
  onClose,
}) {
  const [selected, setSelected] = useState(null);

  const keyFor = (t) => `${t.homeId}:${t.zoneId?.join('_')}`;
  const selectedKey = selected ? keyFor(selected) : null;
  // Re-read the CURRENT target from the live list, so a zone that became locked
  // (entered Holiday / Override / went offline) while the modal is open can no
  // longer be copied to even if it was selected earlier.
  const current = selectedKey
    ? targets.find((t) => keyFor(t) === selectedKey)
    : null;
  const canCopy = Boolean(current) && !current.settingsLocked && !loading;

  return (
    <ModalShell labelledBy="copy-week-title" onClose={onClose}>
      <h2 id="copy-week-title" className="schedule-modal__title">
        Copy schedule to another zone
      </h2>
      <p className="schedule-modal__desc">
        Copies this week to the zone you choose. You can’t copy to a zone that
        is in Holiday mode, Override, or offline.
      </p>

      <ul className="copy-list" role="radiogroup" aria-label="Target zone">
        {targets.map((t) => {
          const k = keyFor(t);
          return (
            <li key={k}>
              <label
                className={`copy-check${
                  t.settingsLocked ? ' copy-check--disabled' : ''
                }`}
              >
                <input
                  type="radio"
                  name="copy-week-target"
                  checked={selectedKey === k}
                  disabled={t.settingsLocked}
                  onChange={() => setSelected(t)}
                />
                <span>{t.friendlyName}</span>
              </label>
            </li>
          );
        })}
      </ul>

      {error ? (
        <p className="schedule-modal__error" role="alert">
          {error}
        </p>
      ) : null}

      <div className="schedule-modal__actions">
        <button
          type="button"
          className="schedule-modal__save"
          disabled={!canCopy}
          aria-busy={loading}
          onClick={() => onCopy(current)}
        >
          {loading ? 'Copying…' : 'Copy'}
        </button>
        <button
          type="button"
          className="schedule-modal__cancel"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </ModalShell>
  );
}
